import { useState } from 'react';
import { apiClient } from '../../../api/httpClient';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/;

export function useGuestEmailVerification() {
  const [email, setEmail] = useState('');
  const [checking, setChecking] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const onVerifyEmail = async () => {
    setErrorMsg('');
    setEmailExists(false);
    const valid = EMAIL_PATTERN.test(email.trim());
    if (!valid) {
      setErrorMsg('Please enter a valid email address.');
      return;
    }
    setChecking(true);
    try {
      await apiClient('/email-exists', 'POST', { email: email.trim() });
      setEmailVerified(true);
    } catch (error) {
      if (error?.detail === 'Email already exists') {
        setEmailExists(true);
        setEmailVerified(false);
      } else {
        setErrorMsg('We could not verify the email. Please try again.');
      }
    } finally {
      setChecking(false);
    }
  };

  const resetVerification = () => {
    setEmailVerified(false);
    setEmailExists(false);
    setErrorMsg('');
  };

  return {
    email,
    setEmail,
    checking,
    emailVerified,
    emailExists,
    errorMsg,
    onVerifyEmail,
    resetVerification,
  };
}
